module.exports = __webpack_public_path__ + "static/img/header_bg.b681d06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/header_bg.png
// module id = ZKG4
// module chunks = 1 3